import { IHttpParamSerializer, IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import {
  ITableVacancyData,
  ITableVacancyRes,
  TableVacancy
} from './table-vacancy';
import { ApiService } from '../api-service/api.service';
import { CreateVacancy } from '../../entities/create-vacancy';
import { cloneDeep } from 'lodash-es';

export class VacancyService {
  static $inject = ['$http', 'GmcApi', 'ApiService', '$httpParamSerializer'];
  vacancy: CreateVacancy;

  constructor(
    private $http: IHttpService,
    private gmcApi: GmcApi,
    private apiService: ApiService,
    private $httpParamSerializer: IHttpParamSerializer
  ) {}

  getVacancyCreationVariables(): IPromise<any> {
    return this.$http
      .get<any>(this.gmcApi.vacancy.getCvCreationVariables)
      .then((response) => {
        return response.data.fields;
      });
  }

  getAllVacancies(params: object = {}): IPromise<ITableVacancyData> {
    return this.apiService
      .post<ITableVacancyRes>(
        '/vacancy/all',
        this.$httpParamSerializer(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((res) => {
        return {
          count: res.count,
          pages: res.pages || 0,
          vacancies: res.data
            .filter((item) => !!item.user_id)
            .map((item) => {
              if (item.user_id) {
                return new TableVacancy(item);
              }
            })
        };
      });
  }

  getVacanciesByEmplID(id, params: object = {}): IPromise<ITableVacancyData> {
    return this.apiService
      .post<ITableVacancyRes>(
        `/vacancy/all/${id}`,
        this.$httpParamSerializer(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((res) => {
        return {
          pages: res.pages || 0,
          vacancies: res.data
            .filter((item) => !!item.user_id)
            .map((item) => {
              if (item.user_id) {
                return new TableVacancy(item);
              }
            })
        };
      });
  }

  getAllVacanciesPublic(): IPromise<any> {
    return this.apiService
      .get<ITableVacancyRes>('/vacancy/all/light')
      .then((res) => {
        return {
          vacancies: res.data
            .filter((item) => !!item.user_id)
            .map((item) => {
              if (item.user_id) {
                return new TableVacancy(item);
              }
            })
        };
      });
  }

  getEmployerVacancies(params: object = {}): IPromise<any> {
    return this.apiService
      .get<ITableVacancyRes>(`/vacancy/my`, { params })
      .then((response) => {
        return response;
      });
  }

  postVacancy(vacancy): IPromise<any> {
    return this.$http
      .post<any>(this.gmcApi.vacancyApi, vacancy)
      .then((response) => {
        console.log(response);
        return response.data;
      });
  }

  preAddVacancyValidate(vacancy): IPromise<any> {
    return this.apiService
      .post<any>(`/validate/vacancy`, vacancy)
      .then((res) => {
        return res;
      });
  }

  getVacancyById(id: string): IPromise<any> {
    return this.$http
      .get<any>(`${this.gmcApi.vacancyApi}/${id}`)
      .then((response) => {
        return response.data.data;
      });
  }

  getActiveVacanciesCount(): IPromise<any> {
    return this.apiService.get<any>('/vacancy/all/count').then((data) => {
      return data;
    });
  }

  deleteVacancy(id): IPromise<any> {
    return this.apiService.delete<any>(`/vacancy/${id}`).then((response) => {
      return response.text;
    });
  }

  updateVacancy(updatedVacancy): IPromise<any> {
    return this.apiService
      .put<any>(`/vacancy/${updatedVacancy._id}`, updatedVacancy)
      .then((res) => {
        // const newVac = cloneDeep(updatedVacancy);
        // Object.assign(this.vacancy, newVac);
        return res;
      });
  }

  updateVacancyStatus(vacancyId: string): IPromise<IVacancyStatusRes> {
    return this.apiService
      .put<any>(`/vacancy/active/${vacancyId}`)
      .then((res: IVacancyStatusRes) => {
        return res;
      });
  }
}

export interface IVacancyStatusRes {
  text: string;
  status: boolean;
  isError: boolean;
}



// WEBPACK FOOTER //
// ./app/core/services/vacancy/vacancy.service.ts